'use es6';

import { getSenderId, getSenderType } from '../../common-message-format/operators/commonMessageFormatGetters';
export const areFromSameSender = (messageA, messageB) => {
  const senderIdSelector = getSenderId;
  const senderTypeSelector = getSenderType;
  return senderIdSelector(messageA) === senderIdSelector(messageB) && senderTypeSelector(messageA) === senderTypeSelector(messageB);
};